import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BankAccountClient } from '../clients/oreg-api/account.client';
import { Account } from '../models/account.model';

@Injectable({ providedIn: 'root' })
export class AccountsCommand {
  constructor(private accountClient: BankAccountClient) {}

  addAccount(account: Account): Observable<Account> {
    return this.accountClient.addAccount(account);
  }

  updateAccount(account: Account): Observable<Account> {
    return this.accountClient.updateAccount(account);
  }

  attestera(accountId: string) {
    return this.accountClient.attesteraAccount(accountId);
  }
}
